<template>
  <div class="show">
    <cling-viewer :state="video" :on-activate="onActivate"></cling-viewer>
    <!--
  <label>
    <select v-model="template">
    </select>
    Template
  </label>
  <label>
    <select v-model="onActivate">
      <option value="play">Play</option>
      <option value=".5">Slowmo</option>
      <option value="pause">Pause</option>
    </select>
    Mode
    </label>
    -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import clingViewer from './viewer'
export default {
  name: 'show',
  data() {
    return {
      template: null,
      onActivate: 'pause'
    }
  },
  components: { clingViewer },
  computed: {
    ...mapGetters(['video'])
  }
}
</script>

<style lang="scss" scoped>

</style>
